<div class="row" style="margin-bottom: 20px;">
    <div class="col-12">
      <button (click)="exportExcel()" style="float: right;" type="button" class="btn btn-success">
        <span class="material-icons">
          get_app
          </span>
      </button>
      <button (click)="exportToPDF()" style="float: right; margin-right: 5px;" type="button" class="btn btn-primary">
        <span class="material-icons">
          picture_as_pdf
          </span>
      </button>
    </div>
  </div>
<div class="container shadow" style="margin-bottom: 30px;">
    <div class="col-12">
        <table class="table table-hover" style="margin-bottom: 20px;" id="contentToConvert">
            <thead>
                <tr>
                    <th style="color:#4C52BC" scope="col">Şube Adı</th>
                    <th style="color:#4C52BC" scope="col">İskonto Nedeni</th>
                    <th style="color:#4C52BC" scope="col">İskonto Açıklama</th>
                    <th style="color:#4C52BC" scope="col">İskonto Oranı</th>
                    <th style="color:#4C52BC" scope="col">Adisyon No</th>
                    <th style="color:#4C52BC" scope="col">İskonto Yapan</th>
                    <th style="color:#4C52BC" scope="col">İndirim</th>
                    <th style="color:#4C52BC" scope="col">Kapanma Zamanı</th>
                    <th style="color:#4C52BC" scope="col">Garson</th>                    
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of this.rs.discountReportDetail;let c=index">
                    <td>{{item.SUBE_ADI}}</td>
                    <td>{{item.ISKONTO_NEDENI}}</td>
                    <td>{{item.ISKONTO_ACIKLAMA}}</td>
                    <td>% {{item.ISKONTO_ORANI  *100 | number}}</td>
                    <td><a (click) = "getFolioDetail(item.ADISYONNO)"><span style="text-decoration: underline;cursor: pointer;">{{item.ADISYONNO}}</span></a></td>
                    <td>{{item.ISKONTO_YAPAN}}</td>
                    <td>{{item.INDIRIM | currency}}</td>
                    <td>{{item.K_ZAMAN | date :  "dd.MM.yyyy h:mm"}}</td>
                    <td>{{item.GARSON}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div> 
